module.exports = __webpack_public_path__ + "images/interview-Capgemini-2.svg";